import React from 'react'
import classnames from 'classnames'
import { formattedTime } from '../utils'
import styles from './styles'

const FooterAudio = ({
  audio,
  audioCurrentTime,
  audioDuration,
  showDownload = true,
  hiddeDownloadInMobile = false
}) => (
  <div className="footer-audio">
    {audio.name && (
      <div className="wrapper-tag-name">
        <div className="tag-name">{audio.name}</div>
      </div>
    )}

    <div className="current-time">
      {formattedTime(audioCurrentTime)} / {formattedTime(audioDuration)}
    </div>
    {showDownload && (
      <a
        href={audio.url}
        download={audio.url}
        target="_blanck"
        className={classnames('link-to-download', {
          'hidde-download-in-mobile': hiddeDownloadInMobile
        })}
      >
        <u>Descargar</u>
      </a>
    )}

    <style jsx>{styles}</style>
  </div>
)

export default FooterAudio
